<template>
  <div>
    <v-alert v-if="!usuarioLogado.adminWeb" type="warning" outlined dense class="mb-4">
      Acesso restrito: faça login como administrador para editar questionário.
    </v-alert>

    <v-container v-else> </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "EditarQuestionario",
  components: {},
  computed: {
    ...mapGetters({
      usuarioLogado: "config/getUsuarioLogado",
    }),
  },
};
</script>

<style scoped>
.questionario-wrapper {
  padding-left: 24px;
  padding-right: 24px;
}

@media (max-width: 600px) {
  .questionario-wrapper {
    padding-left: 12px;
    padding-right: 12px;
  }
}
</style>
